export default __webpack_public_path__ + "static/media/telephone-ring.11d034b9.mp3";